import api from './authService';

export const reviewService = {
  getMine: async () => {
    const response = await api.get('/reviews/mine');
    return response.data;
  },

  getAll: async (status) => {
    const response = await api.get('/reviews/all', { params: status ? { status } : {} });
    return response.data;
  },

  getDetail: async (id) => {
    const response = await api.get(`/reviews/${id}`);
    return response.data;
  },

  approve: async (id) => {
    const response = await api.post(`/reviews/${id}/approve`);
    return response.data;
  },

  reject: async (id, rejectedEntries) => {
    const response = await api.post(`/reviews/${id}/reject`, { rejectedEntries });
    return response.data;
  }
};
